/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportSession } from './ImportSession';
import {
    ImportSessionFromJSON,
    ImportSessionFromJSONTyped,
    ImportSessionToJSON,
    ImportSessionToJSONTyped,
} from './ImportSession';
import type { Company } from './Company';
import {
    CompanyFromJSON,
    CompanyFromJSONTyped,
    CompanyToJSON,
    CompanyToJSONTyped,
} from './Company';
import type { Category } from './Category';
import {
    CategoryFromJSON,
    CategoryFromJSONTyped,
    CategoryToJSON,
    CategoryToJSONTyped,
} from './Category';
import type { Invoice } from './Invoice';
import {
    InvoiceFromJSON,
    InvoiceFromJSONTyped,
    InvoiceToJSON,
    InvoiceToJSONTyped,
} from './Invoice';
import type { Organization } from './Organization';
import {
    OrganizationFromJSON,
    OrganizationFromJSONTyped,
    OrganizationToJSON,
    OrganizationToJSONTyped,
} from './Organization';
import type { OrderLabel } from './OrderLabel';
import {
    OrderLabelFromJSON,
    OrderLabelFromJSONTyped,
    OrderLabelToJSON,
    OrderLabelToJSONTyped,
} from './OrderLabel';
import type { BusinessUnit } from './BusinessUnit';
import {
    BusinessUnitFromJSON,
    BusinessUnitFromJSONTyped,
    BusinessUnitToJSON,
    BusinessUnitToJSONTyped,
} from './BusinessUnit';

/**
 * 
 * @export
 * @interface Order
 */
export interface Order {
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Order
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Order
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Order
     */
    updatedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    orderTotal?: number;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    orderTotalCurrency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Order
     */
    date?: Date;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    externalCompanyJoinId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    externalOrderId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    rawOrderData?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    externalOrderLineId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    externalBusinessUnitJoinId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    organizationId?: string;
    /**
     * 
     * @type {Organization}
     * @memberof Order
     */
    organization?: Organization;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    importSessionId?: string | null;
    /**
     * 
     * @type {ImportSession}
     * @memberof Order
     */
    importSession?: ImportSession;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    companyId?: string | null;
    /**
     * 
     * @type {Company}
     * @memberof Order
     */
    company?: Company;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    businessUnitId?: string | null;
    /**
     * 
     * @type {BusinessUnit}
     * @memberof Order
     */
    businessUnit?: BusinessUnit;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    categoryId?: string | null;
    /**
     * 
     * @type {Category}
     * @memberof Order
     */
    category?: Category;
    /**
     * 
     * @type {Array<OrderLabel>}
     * @memberof Order
     */
    labels?: Array<OrderLabel> | null;
    /**
     * 
     * @type {Array<Invoice>}
     * @memberof Order
     */
    invoices?: Array<Invoice> | null;
}

/**
 * Check if a given object implements the Order interface.
 */
export function instanceOfOrder(value: object): value is Order {
    return true;
}

export function OrderFromJSON(json: any): Order {
    return OrderFromJSONTyped(json, false);
}

export function OrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): Order {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'orderTotal': json['orderTotal'] == null ? undefined : json['orderTotal'],
        'orderTotalCurrency': json['orderTotalCurrency'] == null ? undefined : json['orderTotalCurrency'],
        'description': json['description'] == null ? undefined : json['description'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'externalCompanyJoinId': json['externalCompanyJoinId'] == null ? undefined : json['externalCompanyJoinId'],
        'externalOrderId': json['externalOrderId'] == null ? undefined : json['externalOrderId'],
        'rawOrderData': json['rawOrderData'] == null ? undefined : json['rawOrderData'],
        'externalOrderLineId': json['externalOrderLineId'] == null ? undefined : json['externalOrderLineId'],
        'externalBusinessUnitJoinId': json['externalBusinessUnitJoinId'] == null ? undefined : json['externalBusinessUnitJoinId'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'organization': json['organization'] == null ? undefined : OrganizationFromJSON(json['organization']),
        'importSessionId': json['importSessionId'] == null ? undefined : json['importSessionId'],
        'importSession': json['importSession'] == null ? undefined : ImportSessionFromJSON(json['importSession']),
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'company': json['company'] == null ? undefined : CompanyFromJSON(json['company']),
        'businessUnitId': json['businessUnitId'] == null ? undefined : json['businessUnitId'],
        'businessUnit': json['businessUnit'] == null ? undefined : BusinessUnitFromJSON(json['businessUnit']),
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'category': json['category'] == null ? undefined : CategoryFromJSON(json['category']),
        'labels': json['labels'] == null ? undefined : ((json['labels'] as Array<any>).map(OrderLabelFromJSON)),
        'invoices': json['invoices'] == null ? undefined : ((json['invoices'] as Array<any>).map(InvoiceFromJSON)),
    };
}

export function OrderToJSON(json: any): Order {
    return OrderToJSONTyped(json, false);
}

export function OrderToJSONTyped(value?: Order | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'orderTotal': value['orderTotal'],
        'orderTotalCurrency': value['orderTotalCurrency'],
        'description': value['description'],
        'date': value['date'] == null ? value['date'] : value['date'].toISOString(),
        'externalCompanyJoinId': value['externalCompanyJoinId'],
        'externalOrderId': value['externalOrderId'],
        'rawOrderData': value['rawOrderData'],
        'externalOrderLineId': value['externalOrderLineId'],
        'externalBusinessUnitJoinId': value['externalBusinessUnitJoinId'],
        'organizationId': value['organizationId'],
        'organization': OrganizationToJSON(value['organization']),
        'importSessionId': value['importSessionId'],
        'importSession': ImportSessionToJSON(value['importSession']),
        'companyId': value['companyId'],
        'company': CompanyToJSON(value['company']),
        'businessUnitId': value['businessUnitId'],
        'businessUnit': BusinessUnitToJSON(value['businessUnit']),
        'categoryId': value['categoryId'],
        'category': CategoryToJSON(value['category']),
        'labels': value['labels'] == null ? undefined : ((value['labels'] as Array<any>).map(OrderLabelToJSON)),
        'invoices': value['invoices'] == null ? undefined : ((value['invoices'] as Array<any>).map(InvoiceToJSON)),
    };
}

